export default {
  labels: {
    custom: 'Aangepast – Op aanvraag beschikbaar',
    was: 'Was {{amount}} – jaarkorting toegepast',
  },
  tags: {
    preferred: 'Bijzonder populair',
    net_one_time: 'netto eenmalig',
    annual_discount: '-{{percentage}}% jaarlijks',
  },
  buttons: {
    select_plan: 'Kies dit plan',
  },
};
